import { ApiClient } from '../core/ApiClient';
import { i18n } from '../core/I18nManager';
import { ToastManager } from './ToastManager';

export class AuthModal {
    private modal: HTMLElement | null = null;
    private loginForm: HTMLElement | null = null;
    private registerForm: HTMLElement | null = null;
    private user: any = null;

    constructor() {
        this.render();
        this.init();
    }

    private render() {
        if (document.getElementById('authModal')) return;

        const modalHtml = `
            <div id="authModal" class="zen-modal-overlay fixed inset-0 bg-stone-900/50 backdrop-blur-sm z-[3000] flex items-center justify-center opacity-0 pointer-events-none transition-opacity duration-300">
                <div class="bg-white rounded-2xl p-8 max-w-sm w-full mx-4 shadow-2xl border border-stone-200 transform scale-95 transition-transform duration-300 relative">
                    <button id="closeAuthModal" class="absolute top-4 right-4 text-stone-400 hover:text-stone-600">
                        <iconify-icon icon="solar:close-circle-linear" width="24"></iconify-icon>
                    </button>

                    <div id="loginForm">
                        <h3 class="zen-serif text-2xl text-stone-900 mb-2 text-center" data-i18n="login_title">${i18n.t('login_title') || '欢迎回来'}</h3>
                        <p class="text-stone-500 text-sm text-center mb-8" data-i18n="login_subtitle">${i18n.t('login_subtitle') || '请登录以保存您的进度'}</p>
                        
                        <div class="space-y-4">
                            <div>
                                <label class="block text-xs font-medium text-stone-500 mb-1" data-i18n="label_account">${i18n.t('label_account') || '账号'}</label>
                                <input type="text" id="loginAccount" class="w-full px-4 py-2 rounded-lg border border-stone-200 outline-none focus:border-stone-400 transition-colors text-sm" placeholder="邮箱或用户名">
                            </div>
                            <div>
                                <label class="block text-xs font-medium text-stone-500 mb-1" data-i18n="label_password">${i18n.t('label_password') || '密码'}</label>
                                <input type="password" id="loginPassword" class="w-full px-4 py-2 rounded-lg border border-stone-200 outline-none focus:border-stone-400 transition-colors text-sm" placeholder="请输入密码">
                            </div>
                            <button id="submitLogin" class="w-full bg-stone-900 text-stone-50 py-3 rounded-lg hover:bg-stone-800 active:scale-[0.98] transition-all text-sm font-medium">
                                ${i18n.t('login') || '登录'}
                            </button>
                        </div>

                        <div class="relative my-8">
                            <div class="absolute inset-0 flex items-center"><div class="w-full border-t border-stone-100"></div></div>
                            <div class="relative flex justify-center text-xs uppercase"><span class="bg-white px-2 text-stone-400" data-i18n="or_continue_with">${i18n.t('or_continue_with') || '或者通过以下方式'}</span></div>
                        </div>

                        <button id="googleLoginBtn" class="w-full flex items-center justify-center gap-2 border border-stone-200 py-3 rounded-lg hover:bg-stone-50 active:scale-[0.98] transition-all text-sm font-medium text-stone-700">
                            <iconify-icon icon="logos:google-icon" width="18"></iconify-icon>
                            <span>Google 登录</span>
                        </button>

                        <p class="mt-8 text-center text-xs text-stone-500">
                            <span data-i18n="no_account">${i18n.t('no_account') || '还没有账号？'}</span>
                            <button id="switchToRegister" class="text-stone-900 font-semibold hover:underline" data-i18n="go_register">${i18n.t('go_register') || '立即注册'}</button>
                        </p>
                    </div>

                    <div id="registerForm" class="hidden">
                        <h3 class="zen-serif text-2xl text-stone-900 mb-2 text-center" data-i18n="register_title">${i18n.t('register_title') || '创建账号'}</h3>
                        <p class="text-stone-500 text-sm text-center mb-8" data-i18n="register_subtitle">${i18n.t('register_subtitle') || '开始您的禅意拼图之旅'}</p>
                        
                        <div class="space-y-4">
                            <div>
                                <label class="block text-xs font-medium text-stone-500 mb-1" data-i18n="label_username">${i18n.t('label_username') || '昵称'}</label>
                                <input type="text" id="regUsername" class="w-full px-4 py-2 rounded-lg border border-stone-200 outline-none focus:border-stone-400 transition-colors text-sm" placeholder="您的游戏昵称">
                            </div>
                            <div>
                                <label class="block text-xs font-medium text-stone-500 mb-1" data-i18n="label_account">${i18n.t('label_account') || '账号'}</label>
                                <input type="text" id="regAccount" class="w-full px-4 py-2 rounded-lg border border-stone-200 outline-none focus:border-stone-400 transition-colors text-sm" placeholder="用于登录的账号">
                            </div>
                            <div>
                                <label class="block text-xs font-medium text-stone-500 mb-1" data-i18n="label_password">${i18n.t('label_password') || '密码'}</label>
                                <input type="password" id="regPassword" class="w-full px-4 py-2 rounded-lg border border-stone-200 outline-none focus:border-stone-400 transition-colors text-sm" placeholder="至少 6 位字符">
                            </div>
                            <button id="submitRegister" class="w-full bg-stone-900 text-stone-50 py-3 rounded-lg hover:bg-stone-800 active:scale-[0.98] transition-all text-sm font-medium">
                                ${i18n.t('go_register') || '注册'}
                            </button>
                        </div>

                        <p class="mt-8 text-center text-xs text-stone-500">
                            <span data-i18n="has_account">${i18n.t('has_account') || '已有账号？'}</span>
                            <button id="switchToLogin" class="text-stone-900 font-semibold hover:underline" data-i18n="go_login">${i18n.t('go_login') || '立即登录'}</button>
                        </p>
                    </div>
                </div>
            </div>
        `;
        document.body.insertAdjacentHTML('beforeend', modalHtml);
    }

    private init() {
        this.modal = document.getElementById('authModal');
        this.loginForm = document.getElementById('loginForm');
        this.registerForm = document.getElementById('registerForm');

        this.bindEvents();
        // checkLoginStatus 不应在此处重复执行，因为 Navbar 也会执行
        // this.checkLoginStatus(); 
    }

    private bindEvents() {
        // 关闭按钮
        document.getElementById('closeAuthModal')?.addEventListener('click', () => this.hide());

        // 切换
        document.getElementById('switchToRegister')?.addEventListener('click', () => this.show('register'));
        document.getElementById('switchToLogin')?.addEventListener('click', () => this.show('login'));

        // 登录提交
        document.getElementById('submitLogin')?.addEventListener('click', () => this.handleLogin());
        
        // 注册提交
        document.getElementById('submitRegister')?.addEventListener('click', () => this.handleRegister());

        // Google 登录
        document.getElementById('googleLoginBtn')?.addEventListener('click', () => {
            ApiClient.loginWithGoogle();
        });

        // 全局点击关闭下拉菜单
        document.addEventListener('click', () => this.closeUserDropdown());
    }

    public show(form: 'login' | 'register' = 'login') {
        this.toggleForm(form);
        this.modal?.classList.add('active');
        this.modal?.classList.remove('opacity-0', 'pointer-events-none');
        const content = this.modal?.querySelector('div');
        if (content) {
            content.classList.remove('scale-95');
            content.classList.add('scale-100');
        }
    }

    private hide() {
        this.modal?.classList.remove('active');
        this.modal?.classList.add('opacity-0', 'pointer-events-none');
        this.modal?.querySelector('div')?.classList.add('scale-95');
        this.modal?.querySelector('div')?.classList.remove('scale-100');
    }

    private toggleForm(form: 'login' | 'register') {
        if (form === 'login') {
            this.loginForm?.classList.remove('hidden');
            this.registerForm?.classList.add('hidden');
        } else {
            this.loginForm?.classList.add('hidden');
            this.registerForm?.classList.remove('hidden');
        }
    }

    private async handleLogin() {
        const account = (document.getElementById('loginAccount') as HTMLInputElement).value;
        const password = (document.getElementById('loginPassword') as HTMLInputElement).value;

        if (!account || !password) {
            ToastManager.warning(i18n.t('msg_fill_info'));
            return;
        }

        try {
            const data = await ApiClient.post<{ user: any }>('/api/auth/login', { account, password });
            ToastManager.success(i18n.t('login_title')); // Welcome back
            this.updateUserUI(data.user);
            this.hide();
            window.dispatchEvent(new CustomEvent('auth-status-changed', { 
                detail: { isLoggedIn: true, user: data.user } 
            }));
        } catch (e: any) {
            // Error is handled by ApiClient globally
        }
    }

    private async handleRegister() {
        const username = (document.getElementById('regUsername') as HTMLInputElement).value;
        const account = (document.getElementById('regAccount') as HTMLInputElement).value;
        const password = (document.getElementById('regPassword') as HTMLInputElement).value;

        if (!username || !account || !password) {
            ToastManager.warning(i18n.t('msg_fill_info'));
            return;
        }

        try {
            await ApiClient.post('/api/auth/register', { username, account, password });
            ToastManager.success(i18n.t('msg_register_success'));
            this.toggleForm('login');
        } catch (e: any) {
             // Error is handled by ApiClient globally
        }
    }

    private async checkLoginStatus() {
        try {
            // 使用 skipErrorToast 防止未登录时弹出错误提示
            const user = await ApiClient.get('/api/auth/me', undefined, { skipErrorToast: true });
            this.updateUserUI(user);
        } catch (e) {
            this.updateUserUI(null);
        }
    }

    public updateUserUI(user: any) {
        this.user = user;
        const btnText = document.getElementById('loginBtnText');
        const avatarContainer = document.getElementById('userAvatarContainer');
        const avatarIcon = document.getElementById('userAvatarIcon');

        if (user) {
            if (btnText) btnText.textContent = user.username;
            if (avatarContainer && user.avatar) {
                avatarContainer.innerHTML = `<img src="${user.avatar}" class="w-full h-full object-cover">`;
            }
        } else {
            if (btnText) btnText.textContent = i18n.t('login');
            if (avatarContainer) {
                avatarContainer.innerHTML = `<iconify-icon id="userAvatarIcon" icon="solar:user-linear" width="14" stroke-width="1.5"></iconify-icon>`;
            }
        }
    }

    private logout() {
        ApiClient.post('/api/auth/logout', {}).finally(() => {
            this.user = null;
            this.closeUserDropdown();
            window.dispatchEvent(new CustomEvent('auth-status-changed', { 
                detail: { isLoggedIn: false, user: null } 
            }));
        });
    }

    // ===== Dropdown Logic =====

    public toggleUserDropdown() {
        let dropdown = document.getElementById('userDropdown');
        
        if (!dropdown) {
            this.createUserDropdown();
            dropdown = document.getElementById('userDropdown');
        }
        
        if (dropdown) {
            const isHidden = dropdown.classList.contains('opacity-0');
            if (isHidden) {
                dropdown.classList.remove('opacity-0', 'pointer-events-none', 'scale-95');
                dropdown.classList.add('opacity-100', 'scale-100');
            } else {
                this.closeUserDropdown();
            }
        }
    }

    public closeUserDropdown() {
        const dropdown = document.getElementById('userDropdown');
        if (dropdown) {
            dropdown.classList.add('opacity-0', 'pointer-events-none', 'scale-95');
            dropdown.classList.remove('opacity-100', 'scale-100');
        }
    }

    private createUserDropdown() {
        const loginBtn = document.getElementById('loginBtn');
        if (!loginBtn) return;

        const dropdown = document.createElement('div');
        dropdown.id = 'userDropdown';
        dropdown.className = 'absolute right-0 top-full mt-2 w-48 bg-white/95 backdrop-blur-xl rounded-xl shadow-2xl border border-stone-200 py-2 opacity-0 pointer-events-none transition-all duration-300 z-50 origin-top-right transform scale-95';
        
        dropdown.innerHTML = `
            <div class="px-4 py-3 border-b border-stone-100 mb-1">
                <p class="text-[10px] uppercase tracking-widest text-stone-400 font-bold mb-0.5">Account</p>
                <p class="text-sm font-semibold text-stone-900 truncate">${this.user?.username || 'User'}</p>
            </div>
            <button id="menuProfile" class="w-full text-left px-4 py-2 text-sm text-stone-600 hover:bg-stone-50 hover:text-stone-900 transition-colors flex items-center gap-2">
                <iconify-icon icon="solar:user-circle-linear" width="18"></iconify-icon>
                <span>${i18n.t('profile') || '个人主页'}</span>
            </button>
            <button id="menuHistory" class="w-full text-left px-4 py-2 text-sm text-stone-600 hover:bg-stone-50 hover:text-stone-900 transition-colors flex items-center gap-2">
                <iconify-icon icon="solar:history-linear" width="18"></iconify-icon>
                <span>${i18n.t('game_history') || '历史成绩'}</span>
            </button>
            <div class="h-px bg-stone-100 my-1"></div>
            <button id="menuLogout" class="w-full text-left px-4 py-2 text-sm text-rose-500 hover:bg-rose-50 transition-colors flex items-center gap-2">
                <iconify-icon icon="solar:logout-linear" width="18"></iconify-icon>
                <span>${i18n.t('logout') || '退出登录'}</span>
            </button>
        `;

        if (loginBtn.parentElement) {
            loginBtn.parentElement.classList.add('relative');
            loginBtn.insertAdjacentElement('afterend', dropdown);
        }

        dropdown.querySelector('#menuProfile')?.addEventListener('click', (e) => {
            e.stopPropagation();
            this.closeUserDropdown();
            window.location.href = 'profile.html';
        });

        dropdown.querySelector('#menuHistory')?.addEventListener('click', (e) => {
            e.stopPropagation();
            this.closeUserDropdown();
            window.location.href = 'history.html';
        });

        dropdown.querySelector('#menuLogout')?.addEventListener('click', (e) => {
            e.stopPropagation();
            if (confirm(i18n.t('msg_logout_confirm') || '确定退出登录吗？')) {
                this.logout();
            }
        });
    }
}
